import { Phone, CalendarCheck } from "lucide-react";

export function StickyCallBar() {
  return (
    <div
      data-testid="sticky-call-bar"
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t-2 border-primary shadow-[0_-8px_30px_rgb(0,0,0,0.12)]"
    >
      <div className="grid grid-cols-2">
        <a
          href="tel:+19712553874"
          data-testid="sticky-call-button"
          className="btn-press flex items-center justify-center gap-2 py-4 font-bold text-sm bg-primary text-white"
        >
          <Phone className="w-4 h-4" strokeWidth={2} />
          Call Now
        </a>
        <a
          href="#book"
          data-testid="sticky-book-button"
          className="btn-press flex items-center justify-center gap-2 py-4 font-bold text-sm bg-accent text-white"
        >
          <CalendarCheck className="w-4 h-4" strokeWidth={2} />
          Book $249 Sweep
        </a>
      </div>
    </div>
  );
}
